import React from 'react';
import { Button } from '@mantine/core';
import { saveAs } from 'file-saver';
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  ImageRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
} from 'docx';
import placeholder from '../assets/placeholder.png';

const ExportDOCX = ({ data }) => {
  // Convert image URL to binary
  const toBinary = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return await blob.arrayBuffer(); // Return binary buffer
    } catch (error) {
      console.error(`Error fetching image: ${url}`, error);
      const fallback = await fetch(placeholder);
      const fallbackBlob = await fallback.blob();
      return await fallbackBlob.arrayBuffer();
    }
  };

  // Export DOCX
  const exportDOCX = async () => {
    const tableRows = [];

    // Header Row
    tableRows.push(
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph('Sr. No')],
            width: { size: 10, type: WidthType.PERCENTAGE },
            shading: { fill: '2C7A3B' }, // Green background
          }),
          new TableCell({
            children: [new Paragraph('Name')],
            width: { size: 20, type: WidthType.PERCENTAGE },
            shading: { fill: '2C7A3B' },
          }),
          new TableCell({
            children: [new Paragraph('Batch Code')],
            width: { size: 20, type: WidthType.PERCENTAGE },
            shading: { fill: '2C7A3B' },
          }),
          new TableCell({
            children: [new Paragraph('Photo')],
            width: { size: 30, type: WidthType.PERCENTAGE },
            shading: { fill: '2C7A3B' },
          }),
          new TableCell({
            children: [new Paragraph('Created At')],
            width: { size: 30, type: WidthType.PERCENTAGE },
            shading: { fill: '2C7A3B' },
          }),
        ],
      })
    );

    // Student Data Rows
    for (let i = 0; i < data.length; i++) {
      const student = data[i];
      const imgUrl = student.photo1
        ? `https://ppxxub.online/apis/image-proxy.php?name=${student.photo1}`
        : placeholder;

      const imgBinary = await toBinary(imgUrl);

      const imageRun = new ImageRun({
        data: imgBinary,
        transformation: { width: 180, height: 120 },
      });

      const imageCell = new TableCell({
        children: [
          new Paragraph({
            children: [imageRun],
            alignment: 'center',
          }),
        ],
        verticalAlign: 'center',
      });

      tableRows.push(
        new TableRow({
          children: [
            new TableCell({ children: [new Paragraph(`${i + 1}`)] }),
            new TableCell({ children: [new Paragraph(student.name)] }),
            new TableCell({ children: [new Paragraph(student.batch_code)] }),
            imageCell,
            new TableCell({
              children: [
                new Paragraph(new Date(student.created_at).toLocaleString()),
              ],
            }),
          ],
        })
      );
    }

    // Document Creation
    const doc = new Document({
      sections: [
        {
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: 'Student Details',
                  bold: true,
                  size: 28,
                }),
              ],
            }),
            new Paragraph(' '),
            new Table({
              rows: tableRows,
              width: {
                size: 100,
                type: WidthType.PERCENTAGE,
              },
            }),
          ],
        },
      ],
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, 'student-details.docx');
  };

  return (
    <Button color="yellow" variant="outline" onClick={exportDOCX}>
      Export DOCX
    </Button>
  );
};

export default ExportDOCX;
